import instance from "../components/general/AxiosInterceptor";
import localReferentielApis from "../localReferentiel/others/localReferentielApisMapping";
import localReferentielDummyData from "../localReferentiel/others/localReferentielDummyData";

export const localReferentielApi = (referentielKey) => {
  console.log(
    "localReferentielDummyData[referentielKey]",
    localReferentielDummyData[referentielKey]
  );
  if (Boolean(localReferentielApis[referentielKey])) {
    return instance.get(localReferentielApis[referentielKey]);
  } else {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            body: localReferentielDummyData[referentielKey],
          },
        });
      }, 2000);
    });
  }
};
